<template>
  <div class="TeachersList">
      <van-tabs>
        <van-tab v-for="(item,index) in district" :key="index" :title="item.name">
          
          内容 {{ index }}
          <div class="teachbox">
            <ul>
              <li>
                <div class="teachinfo">
                  <h1>秦迎风</h1>                  
                  <van-tag round type="warning">钢琴</van-tag>
                  <p> 张锦老师简介：毕业于西南师范大学音乐学院钢琴表演专业。贵州省音乐家协会会员，钢琴学会会员。贵阳一中新世界国际学校特聘钢琴教师。中国音乐家协会考级考官。现任教于贵州师范学院音乐舞蹈学院钢琴教师。</p>
                </div>
                <van-image
                  width="50em"
                  height="10em"
                  fit="cover"
                  src="http://gzma.maple.ren/upload/image/20170502/6362933025142184233690943.jpg"
                />
              </li>
              <li>
                <div class="teachinfo">
                  <h1>秦迎风</h1>                  
                  <van-tag round type="warning">钢琴</van-tag>
                  <p> 张锦老师简介：毕业于西南师范大学音乐学院钢琴表演专业。贵州省音乐家协会会员，钢琴学会会员。贵阳一中新世界国际学校特聘钢琴教师。中国音乐家协会考级考官。现任教于贵州师范学院音乐舞蹈学院钢琴教师。</p>
                </div>
                <van-image
                  width="50em"
                  height="10em"
                  fit="cover"
                  src="http://gzma.maple.ren/upload/image/teacher/2018/8/1533343506.jpg"
                />
              </li>
              <li>
                <div class="teachinfo">
                  <h1>秦迎风</h1>                  
                  <van-tag round type="warning">钢琴</van-tag>
                  <p> 贵州师范大学音乐学院钢琴副教授,硕士研究生,贵州省音协会员,钢琴学会会员,中国音协考级考官,2002年毕业于四川音乐学院钢琴系并任教贵州师范大学音乐学院,从教以来发表论文十余篇</p>
                </div>
                <van-image
                  width="50em"
                  height="10em"
                  fit="cover"
                  src="http://gzma.maple.ren/upload/image/teacher/2019/3/1553445895.jpg"
                />
              </li>
              <li>
                <div class="teachinfo">
                  <h1>秦迎风</h1>                  
                  <van-tag round type="warning">钢琴</van-tag>
                  <p> 魏世元，贵阳学院钢琴教师，我省知名指挥、钢琴伴奏。</p>
                </div>
                <van-image
                  width="50em"
                  height="10em"
                  fit="cover"
                  src="http://gzma.maple.ren/upload/image/20170421/6362838447905890659086442.jpg"
                />
              </li>
              <li>
                <div class="teachinfo">
                  <h1>秦迎风</h1>                  
                  <van-tag round type="warning">钢琴</van-tag>
                  <p> 魏世元，贵阳学院钢琴教师，我省知名指挥、钢琴伴奏。</p>
                </div>
                <van-image
                  width="50em"
                  height="10em"
                  fit="cover"
                  src="http://gzma.maple.ren/upload/image/teacher/2017/5/1495810626.jpg"
                />
              </li>
            </ul>
          </div>
        </van-tab>
      </van-tabs>
      <footerTabber />
  </div>
</template>

<script>
import footerTabber from '@/components/footerTabber.vue'
export default {
components: {
    footerTabber
  },
  data(){
    return{
      district:[        
        {id:1,name:"贵阳市",ckb:0},
        {id:2,name:"遵义市",ckb:0},
        {id:3,name:"安顺市",ckb:0},
        {id:4,name:"黔南州",ckb:0},
        {id:5,name:"铜仁市",ckb:0},
        {id:6,name:"黔东南州",ckb:0},
        {id:7,name:"毕节市",ckb:0},
        {id:8,name:"六盘水市",ckb:0},
        {id:9,name:"黔西南州",ckb:0},
      ]
    }
  }
}
</script>

<style>
.TeachersList{padding-bottom: 8vh;}
.teachbox ul li{background: #fff;padding: 10px;width: 92%;box-sizing: border-box;margin: 10px auto;display: flex;justify-content: space-between;align-items: center;border-radius: 5px;}
.teachbox ul li .teachinfo{text-align: left;margin-right: 2%;flex: 6.5;}
.teachbox ul li .teachinfo h1{font-weight: bold;margin-bottom: 10px;}
.teachbox ul li .teachinfo p{color: #666;line-height: 1.5;font-size: 3.2vw;margin: 10px 0;}
.teachbox ul li .van-image{flex: 3.5;}
.teachbox ul li .van-image img{border-radius: 5px;}
</style>